import styled from 'styled-components';
import { Drawer, Flex, DrawerProps } from '@mantine/core';

const HEADER_HEIGHT = '200px';

export const ContainerFlex = styled(Flex).attrs(() => ({
	direction: 'row',
	w: '100%',
	h: '100%',
}))`
	height: calc(100vh - ${HEADER_HEIGHT});
	overflow: hidden;
`;

export const DocumentViewWrapper = styled(Flex).attrs(() => ({
	direction: 'column',
	gap: '1rem',
}))`
	flex: 1;
	min-height: 100%;
	max-height: 100%;
	overflow: hidden;
	padding: 1rem;
	display: flex;
	position: relative;

	& > * {
		max-height: 100%;
		overflow: hidden;
	}
`;

export const RightPanel = styled.div`
	width: 400px;
	height: 100%;
	max-height: 100%;
	border-left: 1px solid #dee2e6;
	overflow: auto;
	padding: 1rem;
`;

export const StyledDrawer = styled(Drawer)<DrawerProps>`
	form {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;

export const DropZone = styled.div<{ $borderColor: string }>`
	min-height: 84px;
	height: 84px;
	border: 2px dashed ${(props) => props.$borderColor};
	border-radius: 8px;
	padding: 1rem;
	text-align: center;
	cursor: pointer;
`;

export const HiddenInput = styled.input`
	display: none;
`;

export const UploadLabel = styled.label`
	cursor: pointer;
	display: block;
`;

export const PreviewContainer = styled.div<{ $borderColor: string }>`
	min-height: 84px;
	height: 84px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	border: 1px solid ${(props) => props.$borderColor};
	border-radius: 8px;
`;

export const FormField = styled.div`
	margin-bottom: 1.5rem;
`;

export const StyledSettingsContainer = styled.div`
	padding: 1rem;
	overflow-x: auto;
	width: 100%;
	position: relative;
`;
